import { inject, Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import {
  DefaultFallbackStrategy,
  DefaultInterceptor,
  DefaultMissingHandler,
  provideTranslocoFallbackStrategy,
  provideTranslocoInterceptor,
  provideTranslocoLoader,
  provideTranslocoMissingHandler,
  Translation,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule,
} from '@jsverse/transloco';
import { provideTranslocoLocale, TranslocoLocaleModule } from '@jsverse/transloco-locale';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { Observable } from 'rxjs';
import { HttpWithoutInterceptorService } from '../services';

@Injectable()
export class TranslocoHttpLoaderGame implements TranslocoLoader {
  private _httpWithoutInterceptorService = inject(HttpWithoutInterceptorService);

  getTranslation(lang: string): Observable<Translation> {
    return this._httpWithoutInterceptorService.get<Translation>(`assets/i18n/${lang}.json`);
  }
}

@NgModule({
  imports: [TranslocoModule],
  exports: [TranslocoModule, TranslocoLocaleModule],
  providers: [],
})
export class TranslocoModuleGame {
  static forRoot(params: { production: boolean }): ModuleWithProviders<TranslocoModuleGame> {
    return {
      ngModule: TranslocoModuleGame,
      providers: [
        provideTranslocoLocale({
          langToLocaleMapping: {
            en: 'en-US',
            fr: 'fr-FR',
            it: 'it-IT',
            es: 'es-ES',
            de: 'de-DE',
            fl: 'fl-FL',
          },
        }),
        provideTranslocoMessageformat(),
        {
          provide: TRANSLOCO_CONFIG,
          useValue: translocoConfig({
            availableLangs: ['en', 'fr', 'it', 'de', 'es', 'fl'],
            reRenderOnLangChange: true,
            defaultLang: 'fr',
            fallbackLang: 'en',
            missingHandler: {
              useFallbackTranslation: true,
              logMissingKey: false,
            },
            prodMode: params.production,
            flatten: {
              aot: params.production,
            },
          }),
        },
        provideTranslocoMessageformat({ locales: ['fr-FR', 'en-EN'] }),
        provideTranslocoLoader(TranslocoHttpLoaderGame),
        provideTranslocoMissingHandler(DefaultMissingHandler),
        provideTranslocoInterceptor(DefaultInterceptor),
        provideTranslocoFallbackStrategy(DefaultFallbackStrategy),
      ],
    };
  }
}
